<template>
  <div class="select_service_wrapper">
    <div class="col-lg-12 col-md-12 col-sm-12" v-if="serviceId != 10">
      <p class="sub-header mr-tp-10">Individual Service Pricings:</p>
    </div>
    <div class="row m-0" v-for="(service, index) in plansList" :key="index">
      <div
        class="col-lg-12 col-md-12 col-sm-12"
        :class="{ 'border-line': serviceId != 10 }"
        v-if="
          (!onefree && service.is_bundle && service.id == '13') ||
          (plansList.length === 1 && service.id == '14')
        "
      >
        <p class="sub-header mr-tp-10" :class="{ 'mr-lt-17': serviceId != 10 }">
          <span>Emergo Pro & Pro Plus Pricings:</span>
        </p>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12" v-if="(onefree && service.id === 2) || !onefree">
        <div
          v-if="
            service.id != 16 &&
            service.id != 8 &&
            (serviceId == 1 ||
              serviceId == 2 ||
              serviceId == 4 ||
              serviceId == 6 ||
              serviceId == 7 ||
              serviceId == 10 ||
              (serviceIdsToDisplay && serviceIdsToDisplay.includes(service.id)))
          "
          class="col-md-12 mr-bt-10 box-border-wrapper"
          :class="{
            'selected-box':
              select_service == service || (service.id == 15 && select_service.id === 16),
            'reg-intel-wrapper': service.id === 2 && onefree
          }"
        >
          <div class="row" v-if="!onefree">
            <div
              class="col-lg-7 col-md-6 col-xs-8 d-flex"
              :class="{
                'col-sm-6': service.id == 7 || service.id == 9 || service.id == 10,
                'col-sm-4':
                  service.id == 1 || service.id == 2 || service.id == 4 || service.id == 15
              }"
            >
              <base-radio
                :id="'service_' + service.id"
                name="selectservice"
                v-model="select_service"
                @change="emitService()"
                :optionValue="service"
                :disabled="onefree"
                v-if="service.id !== 15"
                :label="service"
              >
              </base-radio>
              <input
                type="checkbox"
                :id="'service_' + service.id"
                :disabled="select_service.id === 15 || select_service.id === 16"
                @change="selectedMarketType(service.id)"
                value="true"
                v-if="service.id == 15 || service.id == 16"
                :checked="select_service.id === 15 || select_service.id === 16"
              />
              <label class="default-label" :for="'service_' + service.id"
                ><span>{{ service.name }}</span></label
              >
            </div>
            <div
              class="col-lg-5 col-md-6 col-xs-4 txt-alg-rt"
              v-if="!onefree"
              :class="{
                'col-sm-6': service.id == 7 || service.id == 9 || service.id == 10,
                'col-sm-8':
                  service.id == 1 || service.id == 2 || service.id == 4 || service.id == 15
              }"
            >
              <span
                class="free-service hide_xs_view"
                v-if="
                  !service.is_bundle &&
                  (service.id == 1 || service.id == 2 || service.id == 4 || service.id == 15)
                "
                >Free Service: Product Classification
              </span>
              <span
                class="default-label"
                v-if="service.id !== 2 && service.id !== 15 && service.id !== 14"
              >
                <span v-if="service.id != '8'">${{ service.price }} </span>
              </span>
              <span class="default-label" v-if="service.id === 2 && select_service.id === 2">
                <span v-if="regIntellMarket === '' && country">Free</span>
                <span v-if="regIntellMarket === 'all'">
                  <span>${{ service.price }}</span>
                </span>
                <span class="disp-flex" v-if="regIntellMarket === 'all'"> per year</span>
              </span>
              <span v-if="service.id == 15 && (select_service.id == 15 || select_service.id == 16)">
                ${{ select_service.price }} per year</span
              >
              <span class="default-label" v-if="service.id == 14"
                ><span v-if="todayDate() > renewStartDate() && todayDate() < renewEndDate()"
                  ><span style="text-decoration: line-through">$2899</span
                  ><span
                    ><span> ${{ service.price }}</span>
                  </span>
                </span>
                <span v-else>${{ service.price }}</span></span
              >
              <span class="disp-flex">
                <span v-if="service.id === 9 || service.id === 10"> per use</span>
                <span v-else-if="service.id !== 2 && service.id !== 15"> per year</span>
              </span>
            </div>
            <div class="col-xs-12 market-text">
              <div
                class="col-sm-4 col-xs-12 renews-on"
                v-if="
                  (select_service.id == service.id ||
                    (service.id == 15 && select_service.id === 16)) &&
                  validUntil
                "
              >
                Renews on {{ validUntil | dateFormat }}
              </div>
            </div>
            <div
              class="col-xs-12 free-service-pd display_xs_view"
              v-if="
                !onefree &&
                !service.is_bundle &&
                (service.id == 1 || service.id == 2 || service.id == 4 || service.id == 15)
              "
            >
              <div class="free-service">Free Service: Product Classification</div>
            </div>
          </div>
          <div
            class="pd-lt-28 pd-rt-0 col-lg-12 col-md-12 col-sm-12"
            v-if="service.id != '4' && service.id != '7' && !onefree"
          >
            <hr class="box-int-line" />
            <div class="row">
              <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                <p
                  class="description-pc hide_xs_view"
                  v-if="service.id === 12"
                  v-html="service.description"
                ></p>
              </div>
            </div>
          </div>
          <div class="reg-intel" v-if="service.id === 2">
            <div class="row bundle-wrapper col-md-12 col-sm-12 pl-0 pr-0">
              <div class="col-md-12 col-sm-12 col-xs-12">
                <div class="row" v-if="onefree">
                  <div class="col-xs-12">
                    <input
                      type="radio"
                      :id="'service_' + service.id"
                      name="selectservice"
                      v-model="select_service"
                      @change="emitService(service.price)"
                      :value="service"
                      :disabled="onefree"
                    />

                    <label class="default-label" :for="'service_' + service.id">{{
                      service.name
                    }}</label>
                  </div>
                  <div class="pd-lt-28 pd-rt-0 col-lg-12 col-md-12 col-sm-12">
                    <hr class="box-int-line" />
                  </div>
                </div>
                <div class="row ml-0">
                  <div class="col-md-8 col-sm-7 col-xs-12">
                    <div class="col-xs-12 d-flex align-items-center xs-p-0">
                      <span class="checkbox mr-12">
                        <label>
                          <input
                            type="checkbox"
                            id="regIntell_service_default"
                            name="regIntellServiceDefault"
                            v-model="regIntellServiceDefault"
                            @change="emitRegIntellMarketValues()"
                            :disabled="defaultCountry > 0"
                          />
                          <span class="cr">
                          </span>
                        </label>
                      </span>
                      <div for="regIntell_service">
                        One-time complimentary market
                      </div>
                    </div>

                    <div class="row" v-if="!onefree">
                      <div
                        class="market-note"
                        v-if="service.id === 2 && select_service.id === 2 && !defaultCountry"
                      >
                        <ul>
                          <li>
                            <div class="service-info">
                              <span class="static-text">
                                You must also select one free market. This market will remain
                                complimentary, even if your subscription expires</span
                              >
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 col-sm-5 col-xs-12 service-info pl-0 pr-0">
                    <div class="col-sm-12 static-text">Select Market</div>
                    <div class="col-sm-12">
                      <multiselect
                        :disabled="defaultCountry > 0 || !regIntellServiceDefault"
                        :showLabels="false"
                        :close-on-select="true"
                        :allow-empty="false"
                        class="multiselect-single-dropdown w-100"
                        :class="[
                          defaultCountry > 0 || !regIntellServiceDefault ? 'disable-drop-down' : '',
                          !country ? 'un-selected' : ''
                        ]"
                        :searchable="true"
                        :options="countryList.map((country) => country.country_name)"
                        v-model="country"
                        @input="emitRegIntellMarketValues()"
                        placeholder="Select market"
                      >
                        <span slot="noResult">No matching data</span>
                      </multiselect>
                    </div>
                    <div class="col-sm-12">
                      <p
                        class="errorMsg"
                        v-if="showErrorMsg && regIntellServiceDefault && !country"
                      >
                        Please select a market
                      </p>
                      <p class="errorMsg" v-if="showErrorMsg && !regIntellServiceDefault">
                        Please select Complimentary market
                      </p>
                      <p class="errorMsg" v-if="showErrorMsg && defaultCountry && !regIntellMarket">
                        Please select atleast one option
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-xs-12 all-markets" v-if="!onefree">
              <input
                type="radio"
                id="regIntell_service_all"
                name="regIntellService"
                class="custom_checkbox"
                v-model="regIntellMarket"
                @click="uncheck('all')"
                :disabled="onefree"
                value="all"
              />
              <label for="regIntell_service_all" class="pt-2">
                <span> All markets</span>
              </label>
            </div>
          </div>
          <div class="row" v-if="!onefree && (service.id == 13 || service.id == 14)">
            <div class="col-sm-12 col-xs-12">
              <div class="bundle-sub-heading">
                <span>Services Included :</span>
              </div>
              <div class="col-sm-9 pl-0 reg-tracker">
                <ul>
                  <li
                    class="col-sm-4 pl-0"
                    v-for="services in service.service_list"
                    :key="services"
                  >
                    <div class="service-info">
                      <span class="static-text"> {{ services }}</span>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="pd-lt-28 pd-rt-0 col-lg-12 col-md-12 col-sm-12">
                <hr class="box-int-line" />
              </div>
            </div>
            <div class="col-sm-12 col-xs-12">
              <div class="bundle-sub-heading">
                <span>Additional Storage and Records for Registration Tracker :</span>
              </div>
              <div class="row">
                <div class="col-sm-6 reg-tracker">
                  <ul>
                    <li>
                      <div class="service-info">
                        <span class="service-desc"> 250 records & 2GB storage </span>
                        <span class="static-text"> included in RAMS account purchase</span>
                      </div>
                    </li>
                    <li>
                      <div class="service-info">
                        <span class="static-text">For</span>
                        <span class="service-desc"> 5000+ records,</span>
                        <span class="static-text"> please contact</span>
                        <span class="service-desc"> RAMSHelp@ul.com</span>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="col-md-6 col-sm-6">
                  <div class="row">
                    <div class="col-md-12 col-xs-12 bundle-select txt-alg-rt">
                      <div class="form-group">Registration records and storage upto</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 col-sm-12 col-xs-11">
                      <multiselect
                        v-if="service.id == 13"
                        class="multiselect-single-dropdown"
                        :show-labels="false"
                        :allow-empty="false"
                        :searchable="false"
                        :options="options"
                        v-model="selectedRecordsEmergoPro"
                        label="name"
                        @select="onChangeRecordsEmergoPro"
                      >
                        <template slot="singleLabel" slot-scope="props">
                          <span class="singleLabel_name">{{ props.option.name }}</span
                          ><span class="singleLabel_desc">{{ props.option.desc }}</span>
                        </template>
                        <template slot="option" slot-scope="props">
                          <span class="option_name">{{ props.option.name }}</span
                          ><span class="option_desc">{{ props.option.desc }}</span>
                        </template>
                      </multiselect>
                      <multiselect
                        v-if="service.id == 14"
                        class="multiselect-single-dropdown"
                        :show-labels="false"
                        :allow-empty="false"
                        :searchable="false"
                        :options="options"
                        v-model="selectedRecordsEmergoProPlus"
                        label="name"
                        @select="onChangeRecordsEmergoProPlus"
                      >
                        <template slot="singleLabel" slot-scope="props">
                          <span class="singleLabel_name">{{ props.option.name }}</span
                          ><span class="singleLabel_desc">{{ props.option.desc }}</span>
                        </template>
                        <template slot="option" slot-scope="props">
                          <span class="option_name">{{ props.option.name }}</span
                          ><span class="option_desc">{{ props.option.desc }}</span>
                        </template>
                      </multiselect>
                      <span v-if="selectedRecords == 'displayMessage'">
                        You have current limit of more than 5000 records. </span
                      ><br />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-xs-12">
              <div class="bundle-sub-heading">
                <span>Includes Markets for Regulatory Reports:</span>
              </div>
              <div class="row">
                <div class="col-sm-6 reg-tracker">
                  <ul>
                    <li v-if="service.id == 13">
                      <div class="service-info">
                        <span class="static-text">Access to</span>
                        <span class="service-desc"> 3 Markets </span>
                        <span class="static-text"> included in RAMS account purchase</span>
                      </div>
                    </li>
                    <li v-if="service.id == 14">
                      <div class="service-info">
                        <span class="static-text">Access to</span>
                        <span class="service-desc"> all Markets </span>
                        <span class="static-text"> included in RAMS account purchase</span>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="col-md-6 col-sm-6" v-if="service.id === 13">
                  <div class="row">
                    <div class="col-md-12 col-xs-12 txt-alg-rt select-mrkt">
                      <div class="form-group">Select Markets (Up to 3 markets can be selected)</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 col-sm-12 col-xs-11">
                      <multiselect
                        :showLabels="false"
                        :close-on-select="false"
                        class="multiselect-single-dropdown multiselect-multiple w-reg-rep-65"
                        placeholder="Select Market(s)"
                        label="country_name"
                        track-by="country_name"
                        :multiple="true"
                        :searchable="true"
                        :clear-on-select="false"
                        :options="unsubscribedMarkets"
                        :value="selectedEmergoProCountryList"
                      >
                        <div
                          class="selection-count"
                          slot="selection"
                          slot-scope="{ values, isOpen }"
                        >
                          <template v-if="!isOpen">
                            <img
                              src="/static/images/icons/filter.svg"
                              alt="filter-icon"
                              class="image-size"
                            /><span class="selected-count">{{ values.length }} Selected</span>
                          </template>
                          <template v-else-if="isOpen">
                            <img
                              src="/static/images/icons/filter.svg"
                              alt="filter-icon"
                              class="image-size"
                            />
                          </template>
                        </div>
                        <span slot="option" slot-scope="props">
                          <div
                            class="d-flex"
                            @input="
                              updateSelectedCountryList(
                                props.option,
                                'reg-report',
                                'selectedEmergoProCountryList'
                              )
                            "
                          >
                            <span class="checkbox inline-checkbox">
                              <label>
                                <input
                                  type="checkbox"
                                  :value="props.option"
                                  :checked="selectedEmergoProCountryList.includes(props.option)"
                                />
                                <span
                                  class="cr"
                                  :class="{
                                    'disabled-checkbox': selectedEmergoProCountryList.length == 3
                                  }"
                                >
                                </span>
                              </label>
                            </span>
                            <div
                              class=""
                              :class="{
                                'font-bold': selectedEmergoProCountryList.includes(props.option),
                                'font-wt-400': !selectedEmergoProCountryList.includes(props.option),
                                'disabled-text': selectedEmergoProCountryList.length == 3
                              }"
                              @click="
                                updateSelectedCountryList(
                                  props.option,
                                  'reg-report',
                                  'selectedEmergoProCountryList'
                                )
                              "
                            >
                              {{ props.option.country_name }}
                            </div>
                          </div>
                        </span>
                        <span slot="noResult">No matching data</span>
                      </multiselect>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 reg-report-mrkts" v-if="service.id === 14">
                  <span @click="openRegReportCountryPopup">Show Available Markets</span>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-xs-12" v-if="service.id == 13">
              <div class="bundle-sub-heading">
                <span>Includes 5 team members</span>
              </div>
            </div>
            <div class="col-sm-12 col-xs-12" v-if="service.id == 14">
              <div class="bundle-sub-heading">
                <span>Includes 10 team members</span>
              </div>
              <div class="row">
                <div class="col-xs-12 reg-tracker">
                  <ul>
                    <li>
                      <div class="service-info">
                        <span class="static-text"
                          >Only applicable if account has less than 10 team members at the time of
                          purchase</span
                        >
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-if="!onefree">
            <div class="col-lg-6 col-md-6 col-sm-6 reg-tracker" v-if="service.id == '1'">
              <ul>
                <li v-if="service.id == '1'">
                  <div class="service-info">
                    <span class="service-desc"> 250 records & 2GB storage </span>
                    <span class="static-text"> included in RAMS account purchase</span>
                  </div>
                </li>
                <li v-if="service.id == '1' && records">
                  <div class="records-available service-info">
                    <span class="service-desc"
                      ><span
                        v-if="
                          records.total_limit >= records.default_limit &&
                          records.is_active &&
                          todayDate() <=
                            $options.filters.serviceExpDateFormat(records.valid_until) &&
                          todayDate() >= $options.filters.serviceExpDateFormat(records.valid_from)
                        "
                      >
                        {{ records.total_limit - records.current_utilization }}
                        of {{ records.total_limit }} available
                      </span>
                      <span v-if="records.is_active && records.total_limit < records.default_limit">
                        {{ records.default_limit - records.current_utilization }}
                        of {{ records.default_limit }} available
                      </span></span
                    >
                    <span class="available-upto static-text">
                      (Some options may not be available, adjust the service's current amounts to
                      enable these options.)</span
                    >
                  </div>
                </li>
                <li v-if="service.id == '1'">
                  <div class="service-info">
                    <span class="static-text">For</span>
                    <span class="service-desc"> 5000+ records,</span>
                    <span class="static-text"> please contact</span>
                    <span class="service-desc"> RAMSHelp@ul.com</span>
                  </div>
                </li>
              </ul>
            </div>
            <div class="col-md-6 col-sm-6" v-if="service.id == '1' && !onefree">
              <div class="row">
                <div class="col-md-12 col-xs-12 txt-alg-rt">
                  <p>Registration records and storage upto</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 col-sm-12 col-xs-11">
                  <multiselect
                    class="multiselect-single-dropdown"
                    :show-labels="false"
                    :allow-empty="false"
                    :searchable="false"
                    :options="options"
                    v-model="selectedRecords"
                    label="name"
                    @select="onChangeRecords"
                    v-if="selectedRecords != 'displayMessage'"
                  >
                    <template slot="singleLabel" slot-scope="props">
                      <span class="singleLabel_name">{{ props.option.name }}</span
                      ><span class="singleLabel_desc">{{ props.option.desc }}</span>
                    </template>
                    <template slot="option" slot-scope="props">
                      <span class="option_name">{{ props.option.name }}</span
                      ><span class="option_desc">{{ props.option.desc }}</span>
                    </template>
                  </multiselect>
                  <span v-if="selectedRecords == 'displayMessage'">
                    You have current limit of more than 5000 records. </span
                  ><br />
                </div>
              </div>
            </div>
          </div>

          <div
            class="row bundle-wrapper mr-tp-10 rat-report"
            v-if="service.id === 9 || service.id === 10"
          >
            <div class="col-sm-12 col-xs-12">
              <div class="row">
                <div
                  class="eu-rat-report"
                  :class="{
                    'col-sm-8': service.id == 9,
                    'col-sm-11': service.id == 10
                  }"
                >
                  <ul v-if="service.id == 9">
                    <li>
                      <div class="service-info">
                        <span class="static-text">{{ service.description }}</span>
                      </div>
                    </li>
                    <li>
                      <div class="service-info">
                        <span class="static-text"
                          >How many classification rationale reports do you want to generate?
                        </span>
                        <el-popover
                          placement="bottom-end"
                          trigger="click"
                          @show="infoActive = true"
                          @hide="infoActive = false"
                          width="350"
                        >
                          <div>
                            <div class="mr-bt-10">
                              Reports previously generated remain available for download on your
                              Product Classification dashboard.
                              <br />A "use" is deducted when a new questionnaire is completed.
                            </div>
                          </div>
                          <!-- <template #reference> -->
                          <img
                            class="info-img"
                            src="/static/images/icons/info_icon.svg"
                            v-if="!infoActive"
                            alt="info-icon"
                            slot="reference"
                          />
                          <img
                            class="info-img"
                            src="/static/images/icons/info_icon_active.svg"
                            v-if="infoActive"
                            alt="info-active-icon"
                            slot="reference"
                          />
                          <!-- </template> -->
                        </el-popover>
                      </div>
                    </li>
                  </ul>
                  <ul v-html="service.description" v-if="service.id == 10"></ul>
                  <!-- <ul v-if="service.id == 10">
                    <span v-html="service.description">
                  </ul> -->
                </div>
                <div class="col-md-4 col-sm-4">
                  <div class="row" v-if="service.id !== 10">
                    <div class="col-md-12 col-sm-12 col-xs-11">
                      <multiselect
                        class="multiselect-single-dropdown prod-class-width"
                        :show-labels="false"
                        :allow-empty="false"
                        :searchable="false"
                        :options="getCorrectOptions(service.id)"
                        v-model="selectedRecordsProdClsRat"
                        label="name"
                        track-by="name"
                        @select="onChangeRecordsProdClsRat"
                        v-if="selectedRecordsProdClsRat != 'displayMessage'"
                      >
                        <template slot="singleLabel" slot-scope="props">
                          <span class="singleLabel_name">{{ props.option.name }}</span
                          ><span class="singleLabel_desc">{{ props.option.desc }}</span>
                        </template>
                        <template slot="option" slot-scope="props">
                          <span class="option_name">{{ props.option.name }}</span
                          ><span class="option_desc">{{ props.option.desc }}</span>
                        </template> </multiselect
                      ><br />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row bundle-wrapper mr-tp-10" v-if="serviceId == 7">
            <div class="col-md-6 col-sm-6 col-xs-12 reg-report">
              <div v-if="service.id == 15">
                <base-radio
                  id="3markets"
                  name="market-types"
                  v-model="regReportMarketSelection"
                  @change="selectedMarketType(15)"
                  optionValue="15"
                >
                  <span class="default-label price-info">
                    <span class="fw-500">$599</span>
                    <span> per year ( Includes access to 3 Markets )</span>
                  </span>
                </base-radio>

                <ul>
                  <li>
                    <div class="service-info">
                      <span class="static-text"
                        >Includes access to Regulatory Reports for up to 3 Markets</span
                      >
                    </div>
                  </li>
                  <li>
                    <div class="service-info">
                      <span class="static-text"
                        >Markets can also be selected at a later time in the account settings</span
                      >
                    </div>
                  </li>
                </ul>
              </div>
              <div v-if="service.id == 15">
                <base-radio
                  id="allMarkets"
                  name="market-types"
                  v-model="regReportMarketSelection"
                  @change="selectedMarketType(16)"
                  optionValue="16"
                >
                </base-radio>
                <label class="default-label price-info" for="allMarkets">
                  <span class="fw-500">$1599 </span>
                  <span>per year ( Includes access to all Markets )</span>
                </label>
                <ul>
                  <li>
                    <div class="service-info">
                      <span class="static-text"
                        >Includes access to Regulatory Reports for all available Markets</span
                      >
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-md-6 col-sm-6" v-if="service.id == 15">
              <div class="row">
                <div class="col-md-12 col-xs-12 txt-alg-rt select-mrkt">
                  <p>Select Markets (Up to 3 markets can be selected)</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 col-sm-12 col-xs-11">
                  <multiselect
                    :disabled="regReportMarketSelection == 16"
                    :showLabels="false"
                    :close-on-select="false"
                    class="multiselect-single-dropdown multiselect-multiple w-reg-rep-65"
                    placeholder="Select Market(s)"
                    label="country_name"
                    track-by="country_name"
                    :multiple="true"
                    :searchable="true"
                    :clear-on-select="false"
                    :options="unsubscribedMarkets"
                    :value="selectedCountryList"
                  >
                    <div class="selection-count" slot="selection" slot-scope="{ values, isOpen }">
                      <template v-if="!isOpen">
                        <img
                          src="/static/images/icons/filter.svg"
                          alt="filter-icon"
                          class="image-size"
                        /><span class="selected-count">{{ values.length }} Selected</span>
                      </template>
                      <template v-else-if="isOpen">
                        <img
                          src="/static/images/icons/filter.svg"
                          alt="filter-icon"
                          class="image-size"
                        />
                      </template>
                    </div>
                    <span slot="option" slot-scope="props">
                      <div
                        class="d-flex"
                        @input="
                          updateSelectedCountryList(
                            props.option,
                            'reg-report',
                            'selectedCountryList'
                          )
                        "
                      >
                        <span class="checkbox inline-checkbox">
                          <label>
                            <input
                              type="checkbox"
                              :value="props.option"
                              :checked="selectedCountryList.includes(props.option)"
                            />
                            <span
                              class="cr"
                              :class="{
                                'disabled-checkbox': selectedCountryList.length == 3
                              }"
                            >
                            </span>
                          </label>
                        </span>
                        <div
                          :class="{
                            'font-bold': selectedCountryList.includes(props.option),
                            'font-wt-400': !selectedCountryList.includes(props.option),
                            'disabled-text': selectedCountryList.length == 3
                          }"
                          @click="
                            updateSelectedCountryList(
                              props.option,
                              'reg-report',
                              'selectedCountryList'
                            )
                          "
                        >
                          {{ props.option.country_name }}
                        </div>
                      </div>
                    </span>
                    <span slot="noResult">No matching data</span>
                  </multiselect>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-sm-12 reg-report-mrkts"
            v-if="service.id === REGULATORY_ESSENTIALS_REPORT"
          >
            <span @click="openRegReportCountryPopup">Show Available Markets</span>
          </div>
        </div>
      </div>
    </div>
    <reg-report-countries-popup :countryList="allMarkets"></reg-report-countries-popup>
  </div>
</template>
<script>
import moment from 'moment';
import $ from 'jquery';
import { Popover } from 'element-ui';
import RegReportCountriesPopup from './RegReportCountriesPopup.vue';
import { getAllRegIntelCountries } from '../../../apis/regulatoryIntelligence';
import { getRegReportMarket } from '../../../apis/marketPlace';
import BaseRadio from '../../Common/BaseRadio.vue';
// import BasePopover from '../../Common/BasePopover.vue';

export default {
  props: [
    'plansList',
    'records',
    'options',
    'validUntil',
    'currentUtilization',
    'showErrorMsg',
    'upgrade',
    'defaultCountry',
    'serviceIdsToDisplay',
    'serviceId',
    'defaultSelectedService',
    'onefree',
    'prodClassOptions',
    'prodClassRatOptions'
  ],
  data() {
    return {
      unsubscribedMarkets: [],
      allMarkets: [],
      regReportMarketSelection: 15,
      selectedRecords: {},
      selectedRecordsEmergoPro: {},
      selectedRecordsEmergoProPlus: {},
      selectedRecordsBundle: {},
      selectedRecordsProdCls: {},
      selectedRecordsProdClsRat: {},
      selectedRecordsRegPthway: {},
      regIntellMarket: 'all',
      regIntelPrice: 0,
      select_service: '',
      select_service_reports: '',
      countryList: [],
      country: '',
      selectedCountryList: [],
      selectedEmergoProCountryList: [],
      regIntellServiceDefault: false,
      countryListMultiple: [],
      infoActive: false,
      PRODUCT_CLASSIFICATION: 7,
      CLASSIFICATION_RATIONALE_REPORT: 9,
      REGULATORY_ESSENTIALS_REPORT: 15,
      CLASSIFICATION_RATIONALE_REPORT_EXP_RV: 10
    };
  },
  components: {
    // BasePopover
    RegReportCountriesPopup,
    BaseRadio,
    'el-popover': Popover
  },
  filters: {
    dateFormat(date) {
      return moment(date).format('MM/DD/YYYY');
    },
    serviceExpDateFormat(date) {
      return moment.utc(date).format('YYYY-MM-DD');
    }
  },
  watch: {
    plansList() {
      if (this.defaultSelectedService) {
        this.select_service = this.plansList.find(
          (element) => element.id === this.defaultSelectedService
        );
        this.$emit('selectedService', this.select_service);
      } else {
        [this.select_service] = this.plansList;
      }
      if (this.select_service.id === 13)
        this.$emit('regReportCountriesSelected', this.selectedEmergoProCountryList);
      if (this.select_service.id === 15) {
        this.$emit('regReportCountriesSelected', this.selectedCountryList);
      }
      if (this.select_service.id === 16 || this.select_service.id === 14) {
        this.$emit('regReportCountriesSelected', 'all');
      }
    },
    defaultCountry() {
      if (this.defaultSelectedService) {
        this.select_service = this.plansList.find(
          (element) => element.id === this.defaultSelectedService
        );
        this.$emit('selectedService', this.select_service);
      } else {
        [this.select_service] = this.plansList;
      }
      if (this.select_service.id === 2) {
        if (this.defaultCountry) {
          this.country = this.countryList.find(
            (country) => country.country_id === this.defaultCountry
          ).country_name;
          this.regIntellServiceDefault = true;
        }
        this.initializeMaketValues(this.select_service.price);
      }
    },
    records() {
      const totalLimit = this.records.total_limit;
      let defaultRecords;
      if (totalLimit <= 250) {
        [defaultRecords] = this.options;
      } else if (totalLimit > 250 && totalLimit <= 1000) {
        [, defaultRecords] = this.options;
      } else if (totalLimit > 1000 && totalLimit <= 2000) {
        [, , defaultRecords] = this.options;
      } else if (totalLimit > 2000 && totalLimit <= 3000) {
        [, , , defaultRecords] = this.options;
      } else if (totalLimit > 3000 && totalLimit <= 4000) {
        [, , , , defaultRecords] = this.options;
      } else if (totalLimit > 4000 && totalLimit <= 5000) {
        [, , , , , defaultRecords] = this.options;
      } else if (totalLimit > 5000) {
        defaultRecords = 'displayMessage';
        // please contact us for further assistance
      }
      this.selectedRecords = defaultRecords;
      this.selectedRecordsBundle = defaultRecords;
      this.selectedRecordsEmergoPro = defaultRecords;
      this.selectedRecordsEmergoProPlus = defaultRecords;
      this.initializeSpecial();
      this.emitRecords();
      this.emitRegIntellMarketValues();
      this.emitProdClass();
      this.emitProdClassRat();
      this.emitRegPthway();
    },
    currentUtilization() {
      let defaultRecords;
      if (this.currentUtilization <= 250) {
        [defaultRecords] = this.options;
      } else if (this.currentUtilization > 250 && this.currentUtilization <= 1000) {
        [, defaultRecords] = this.options;
      } else if (this.currentUtilization > 1000 && this.currentUtilization <= 2000) {
        [, , defaultRecords] = this.options;
      } else if (this.currentUtilization > 2000 && this.currentUtilization <= 3000) {
        [, , , defaultRecords] = this.options;
      } else if (this.currentUtilization > 3000 && this.currentUtilization <= 4000) {
        [, , , , defaultRecords] = this.options;
      } else if (this.currentUtilization > 4000 && this.currentUtilization <= 5000) {
        [, , , , , defaultRecords] = this.options;
      } else if (this.currentUtilization > 5000) {
        defaultRecords = 'displayMessage';
        // please contact us for further assistance
      }
      this.selectedRecords = defaultRecords;
      this.selectedRecordsBundle = defaultRecords;
      this.selectedRecordsEmergoPro = defaultRecords;
      this.selectedRecordsEmergoProPlus = defaultRecords;
      this.emitRecords();
      this.emitRegIntellMarketValues();
    }
  },
  methods: {
    selectedMarketType(type) {
      this.regReportMarketSelection = type;
      this.select_service = this.plansList.find((p) => p.id === type);
      this.$emit('selectedService', this.select_service);
      this.$emit('regReportCountriesSelected', type === 15 ? this.selectedCountryList : 'all');
    },
    openRegReportCountryPopup() {
      $('#regReportCountryPopup').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    updateSelectedCountryList(option, serviceType, key) {
      if (this[key].findIndex((c) => c.country_id === option.country_id) === -1) {
        if (this[key].length <= 3 && serviceType === 'reg-report') {
          this[key].push(option);
          this.$nextTick(() => {
            this[key].splice(3, this[key].length);
            this.$emit('regReportCountriesSelected', this[key]);
          });
        }
      } else {
        this[key] = this[key].filter((item) => item.country_id !== option.country_id);
        this.$emit('regReportCountriesSelected', this[key]);
      }
    },
    initializeSpecial() {
      this.selectedRecordsRegPthway = {
        name: '1-Report',
        desc: '$299',
        value: 1,
        storage: '0',
        price: '299'
      };
      this.selectedRecordsProdCls = {
        name: '1-Use',
        desc: '$99',
        value: 1,
        storage: '0',
        price: '99'
      };
      this.selectedRecordsProdClsRat = {
        name: '1-Use',
        desc: '$199',
        value: 1,
        storage: '0',
        price: '199'
      };
    },
    getCorrectOptions(serviceId) {
      let retOptions = [];
      if (serviceId === this.CLASSIFICATION_RATIONALE_REPORT) {
        retOptions = this.prodClassRatOptions;
      }
      return retOptions;
    },
    uncheck(val) {
      if (val === this.regIntellMarket) {
        this.regIntellMarket = '';
        this.selectedCountryList = [];
      } else {
        this.regIntellMarket = val;
      }
      this.emitRegIntellMarketValues();
    },
    defaultCountryEvent() {
      this.emitRegIntellMarketValues();
    },
    regIntellMarketEvent() {
      this.selectedCountryList = [];
      this.regIntelPrice = this.regIntellMarketValue(this.select_service.price);
      this.emitRegIntellMarketValues();
    },
    countryLabel(country) {
      let countryName = country.country_name;
      if (window.innerWidth < 768 && country.length > 40) {
        const i = country.indexOf(' ', 30);
        countryName = `${country.substring(0, i)}<br>${country.substring(i + 1)}`;
      }
      return countryName;
    },
    todayDate() {
      return moment().utc().format('YYYY-MM-DD');
    },
    renewStartDate() {
      return moment.utc('06/01/2022').format('YYYY-MM-DD');
    },
    renewEndDate() {
      return moment.utc('10/01/2022').format('YYYY-MM-DD');
    },
    onChangeRecordsEmergoProPlus(selectedOption) {
      this.selectedRecordsEmergoProPlus = selectedOption;
      this.emitRecords();
    },
    onChangeRecordsEmergoPro(selectedOption) {
      this.selectedRecordsEmergoPro = selectedOption;
      this.emitRecords();
    },
    onChangeRecords(selectedOption) {
      this.selectedRecords = selectedOption;
      this.emitRecords();
    },
    onChangeRegPthwayNo(selectedOption) {
      this.selectedRecordsRegPthway = selectedOption;
      this.emitRegPthway();
    },
    onChangeRecordsProdCls(selectedOption) {
      this.selectedRecordsProdCls = selectedOption;
      this.emitProdClass();
    },
    onChangeRecordsProdClsRat(selectedOption) {
      this.selectedRecordsProdClsRat = selectedOption;
      this.emitProdClassRat();
    },
    emitProdClass() {
      this.$emit('prodClassNosSelected', this.selectedRecordsProdCls);
    },
    emitProdClassRat() {
      this.$emit('prodClassRatNosSelected', this.selectedRecordsProdClsRat);
    },
    emitRegPthway() {
      this.$emit('regpathwayNosSelected', this.selectedRecordsRegPthway);
    },
    onChangeRecordsBundle(selectedOption) {
      this.selectedRecordsBundle = selectedOption;
      this.emitRecords();
    },
    emitRecords() {
      if (this.select_service.id === 13) {
        this.$emit('recordsSelected', this.selectedRecordsEmergoPro);
      } else if (this.select_service.id === 14) {
        this.$emit('recordsSelected', this.selectedRecordsEmergoProPlus);
      } else {
        this.$emit('recordsSelected', this.selectedRecords);
      }
    },
    emitRegIntellMarketValues() {
      if (this.select_service.id === 2) {
        const newList = [];
        this.selectedCountryList.forEach((c) => {
          newList.push(this.countryList.find((each) => each.country_name === c));
        });
        const countryData = this.countryList.find((c) => c.country_name === this.country);
        this.$emit('RegIntellMarketValues', {
          Market: this.regIntellMarket,
          Country: countryData,
          Countries: newList,
          Default_Market: this.regIntellServiceDefault
        });
      }
    },
    emitService() {
      if (this.select_service.id === 2) {
        this.select_service.price = this.regIntellMarketValue(this.regIntelPrice);
        this.emitRegIntellMarketValues();
      }
      if (this.select_service.id === 15 || this.select_service.id === 16) {
        this.regReportMarketSelection = this.select_service.id;
        this.$emit(
          'regReportCountriesSelected',
          this.select_service.id === 15 ? this.selectedEmergoProCountryList : 'all'
        );
      }
      if (this.select_service.id === 13)
        this.$emit('regReportCountriesSelected', this.selectedEmergoProCountryList);
      if (this.select_service.id === 14) this.$emit('regReportCountriesSelected', 'all');
      this.$emit('selectedService', this.select_service);
      this.emitRecords();
    },
    regIntellMarketValue(price) {
      let servicePrice = '';
      if (this.regIntellMarket === '') {
        servicePrice = 0;
      }
      if (this.regIntellMarket === 'all') {
        servicePrice = price;
      }
      return servicePrice;
    },
    async getCountries() {
      const markets = await getRegReportMarket(localStorage.getItem('accountId'));
      this.allMarkets = markets.all_markets;
      this.unsubscribedMarkets = markets.all_markets;
    },
    async initializeMaketValues() {
      // if (this.country) this.countryListMultiple = this.countryList.filter((each) => each.country_name !== this.country);
      // else this.countryListMultiple = [...this.countryList];
      if (this.onefree) {
        this.regIntellMarket = '';
      } else {
        this.regIntellMarket = 'all';
      }
      this.regIntelPrice = this.regIntellMarketValue(this.select_service.price);
      this.select_service.price = this.regIntellMarketValue(this.regIntelPrice);
      this.regIntellMarketEvent();
    }
  },
  async mounted() {
    await this.getCountries();
    if (this.$route.params.serviceId === '2') {
      this.countryList = await getAllRegIntelCountries();
    }
    if (!this.records) {
      [this.selectedRecords] = this.options;
      [this.selectedRecordsBundle] = this.options;
      [this.selectedRecordsEmergoPro] = this.options;
      [this.selectedRecordsEmergoProPlus] = this.options;
      this.emitRecords();
    }
    this.initializeSpecial();
    this.emitProdClass();
    this.emitProdClassRat();
    this.emitRegPthway();
  }
};
</script>
<style scoped>
.pl-30 {
  padding-left: 28px;
}
input[type='checkbox'] {
  width: 16px;
  height: 16px;
}
.errorMsg {
  margin-top: 4px;
  color: red;
}
::v-deep ::marker {
  color: #0b3c61;
}
/* dropdown css */
.el-select-dropdown__item.selected > .check_icon {
  display: block;
}
.el-select-dropdown__item.selected > .options {
  font-weight: 700;
  color: #0b3c61;
}
.el-select-group__wrap::after {
  background: white;
}
.el-select-group__wrap:not(:last-of-type) {
  padding-bottom: 5px;
}
::v-deep .countries-list-select .el-input__icon {
  line-height: 30px;
}
.countries-list-select {
  display: block;
}
::v-deep .countries-list-select .el-input__inner:focus {
  border: 1px solid #000000;
}
::v-deep .countries-list-select .el-input__inner {
  border-radius: 20px;
  border: 1px solid #000000;
  height: 32px;
  width: 100% !important;
  font-weight: 500;
  color: #0b3c61;
  line-height: 20px;
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
  color: green;
}
.w-100,
.w-reg-100 {
  width: 100% !important;
}
.w-reg-rep-65 {
  width: 65% !important;
}
.info-img {
  width: 20px;
  vertical-align: middle;
  margin-left: 4px;
  margin-top: 1px;
}
.info-img-label {
  font-size: 20px;
  line-height: 24px;
  text-align: left;
  vertical-align: middle;
}
.check_icon {
  display: none;
  float: right;
  color: green;
  padding-top: 10px;
}
.label-dropdown {
  vertical-align: sub;
  margin-right: 10px;
}
.select_service_wrapper {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  color: rgba(0, 0, 0, 0.7);
}
.sub-header {
  font-weight: bold;
  font-size: 16px;
  line-height: 18px;
}
.default-label {
  font-size: 18px;
  line-height: 24px;
  text-align: left;
}
.default-desc {
  padding-left: 28px;
  color: #828282;
  font-size: 16px;
  line-height: 16px;
}
::v-deep .selected-box .default-label,
::v-deep .selected-box .service-cost {
  color: #0b3c61;
  font-weight: 500;
}
.table.table-top {
  margin-top: 14px;
}
.box-border-wrapper.selected-box {
  border: 2px solid #4c9e45;
}
.market-note {
  padding: 30px 20px 0px 30px;
  line-height: 20px;
}
.pd-lt-28 {
  padding-left: 28px;
}
.pd-rt-0 {
  padding-right: 0px;
}
.mr-bt-10 {
  margin-bottom: 10px;
}
.mr-bt-20 {
  margin-bottom: 20px;
}
.mr-tp-10 {
  margin-top: 10px;
}
.pl-45 {
  padding-left: 45px !important;
}
.box-sep-line {
  margin: 20px 0px 10px 0px;
}
.box-int-line {
  margin: 10px 0px 10px 0px;
}
.box-border-wrapper {
  padding: 24px;
  border: 1px solid #bdbdbd;
  border-radius: 10px;
}
.service-type {
  margin-top: 5px;
  margin-bottom: 0px;
  font-size: 15px;
}
.description-pc {
  margin-top: 5px;
  margin-bottom: 0px;
  font-size: 15px;
}
.xs_service-type {
  float: left;
  font-size: 15px;
  padding-left: 28px;
}
.txt-alg-rt {
  text-align: right;
}
.font-bold {
  font-weight: bold;
}
.pt-20 {
  padding-top: 20px;
}
.pt-2 {
  padding-top: 2px;
}
.fullprice {
  text-decoration: line-through;
}
/* for radio button*/
[type='radio']:checked,
[type='radio']:not(:checked),
[type='checkbox']:checked,
[type='checkbox']:not(:checked) {
  position: absolute;
  left: -9999px;
}
[type='radio']:checked + label,
[type='radio']:not(:checked) + label,
[type='checkbox']:checked + label,
[type='checkbox']:not(:checked) + label {
  position: relative;
  padding-left: 28px;
  cursor: pointer;
}
[type='radio']:checked + label:before,
[type='radio']:not(:checked) + label:before,
[type='checkbox']:checked + label:before,
[type='checkbox']:not(:checked) + label:before {
  content: '';
  position: absolute;
  left: 0;
  top: 4px;
  width: 18px;
  height: 18px;
  border: 1px solid #0b3c61;
  border-radius: 100%;
  background: #fff;
}
[type='radio']:checked + label:after,
[type='radio']:not(:checked) + label:after,
[type='checkbox']:checked + label:after,
[type='checkbox']:not(:checked) + label:after {
  content: '';
  width: 12px;
  height: 12px;
  background: #0b3c61;
  position: absolute;
  top: 7px;
  left: 3px;
  border-radius: 100%;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
[type='radio']:not(:checked) + label:after,
[type='checkbox']:not(:checked) + label:after {
  opacity: 0;
  -webkit-transform: scale(0);
  transform: scale(0);
}
[type='radio']:checked + label:after,
[type='checkbox']:checked + label:after {
  opacity: 1;
  -webkit-transform: scale(1);
  transform: scale(1);
}
[type='radio']:disabled + label,
[type='checkbox']:disabled + label {
  opacity: 1;
}
/* for checkbox */
.styled-checkbox {
  position: absolute;
  opacity: 0;
}
.styled-checkbox + label {
  position: relative;
  cursor: pointer;
  padding: 0;
}
.styled-checkbox + label:before {
  content: '';
  margin-right: 14px;
  margin-top: 6px;
  display: inline-block;
  vertical-align: text-top;
  width: 14px;
  height: 14px;
  border: 1px solid #0b3c61;
  border-radius: 1px;
}
.styled-checkbox:checked + label:after {
  content: '';
  position: absolute;
  left: 2px;
  top: 12px;
  background: white;
  width: 2px;
  height: 2px;
  box-shadow: 2px 0 0 white, 4px 0 0 white, 4px -2px 0 white, 4px -4px 0 white, 4px -6px 0 white,
    4px -8px 0 white;
  transform: rotate(45deg);
}
.styled-checkbox:checked + label:before {
  background: #0b3c61;
}
.reg-tracker ul,
.reg-report ul,
.reg-intel ul,
.eu-rat-report ul {
  padding-inline-start: 45px;
}
.reg-tracker ul li,
.reg-report ul li,
.reg-intel ul li,
.eu-rat-report ul li {
  color: #00518a;
}
.reg-tracker ul li:not(:last-child),
.reg-report ul li:not(:last-child),
.reg-intel ul li:not(:last-child) .eu-rat-report ul li:not(:last-child) {
  margin-bottom: 10px;
}
.free-service {
  font-family: Roboto;
  font-style: italic;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #204b5a;
  padding-right: 27px;
}
.border-line {
  border-top: 0.7px solid #bdbdbd;
  width: 97%;
  left: 17px;
  margin-top: 10px;
}
.mr-lt-17 {
  margin-left: -17px;
}
.reg-report-mrkts {
  text-align: right;
  margin-top: -15px;
}
.reg-report-mrkts span {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #2f80ed;
  cursor: pointer;
}
.select-mrkt {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.7);
}
.market-text span {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.7);
  text-align: right;
}
.bundle-sub-heading {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.7);
  margin: 10px 0px 10px 28px;
}
.reg-report .fw-500 {
  font-weight: 500;
}
.reg-report .price-info {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.7);
}
.reg-intel .static-text {
  padding-bottom: 5px;
}
.reg-intel .all-markets {
  margin: 10px 0px 0px 15px;
}
.multiselect-single-dropdown.multiselect-multiple .font-wt-400.disabled-text {
  opacity: 0.5;
}
/* reg report dropdown changes ends */

.renews-on {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.7);
  padding-left: 28px;
}
@media screen and (min-width: 990px) {
  .def_ctr_drpdwn {
    position: absolute;
    bottom: 0px;
    width: calc(100% - 43px);
  }
}
@media screen and (max-width: 767px) {
  .reg-tracker ul {
    padding-inline-start: 30px;
  }
  .disp-flex {
    display: inline-flex;
  }
  .hide_xs_view {
    display: none;
  }
  .display_xs_view.free-service-pd {
    margin: 10px 0px;
    padding-right: 0px;
  }
  .display_xs_view .free-service {
    padding-right: 0px;
    padding-left: 30px;
  }
  .reg-tracker ul li,
  .reg-report ul li,
  .reg-intel ul li,
  .eu-rat-report ul li {
    color: rgba(0, 0, 0, 0.7);
  }
  .service-type {
    padding-left: 28px;
  }
  .description-pc {
    padding-left: 28px;
  }
  .pd-lt-28 {
    padding-left: 7px;
  }
  .consulting-type {
    padding-left: 28px;
  }
  .bundle-third-box {
    padding-left: 40px;
  }
  .bundle-cust-box {
    padding-left: 55px;
  }
  .select-mrkt {
    text-align: left;
  }
  .w-reg-rep-65 {
    width: 75% !important;
  }
  .market-text span {
    text-align: left;
    padding-left: 30px;
    padding-top: 10px;
  }
  .renews-on {
    padding-top: 10px;
    padding-left: 30px;
  }
  .bundle-sub-heading {
    margin: 10px 0px 10px 5px;
  }
  .bundle-select {
    text-align: left;
  }
  .reg-intel {
    margin-left: -10px;
  }
  .reg-intel .box-int-line {
    margin-top: 35px;
  }
  .reg-intel .static-text {
    padding-top: 10px;
  }
  .reg-intel .bundle-wrapper {
    padding-left: 0px;
  }
  .reg-intel .all-markets {
    margin-left: 0px;
  }
  .market-note {
    padding: 50px 20px 0px 15px;
  }
  .xs-p-0 {
    padding: 0;
  }
  .eu-rat-report {
    padding-left: 0px;
  }
  .multiselect-single-dropdown.prod-class-width {
    width: 95% !important;
    margin-top: 15px;
  }
}
@media screen and (min-width: 768px) {
  .display_xs_view {
    display: none;
  }
  .service-type {
    padding-left: 45px;
  }
  .description-pc {
    padding-left: 15px;
  }
  .pd-lt-28 {
    padding-left: 28px;
  }
  .service-info,
  ::v-deep .eu-rat-report ul li .service-info {
    color: rgba(0, 0, 0, 0.7);
  }
  .service-info .service-desc {
    font-weight: 500;
  }
  .service-info .static-text {
    font-weight: 400;
  }
  .consulting-type {
    float: right;
  }
  .bundle-cust-box {
    padding-left: 55px;
  }
  .bundle-third-box {
    padding-left: 35px;
    text-align: right;
  }
  .reg-report {
    padding-left: 40px;
  }
  .bundle-wrapper {
    display: flex;
  }
  .pb-10 {
    padding-bottom: 30px;
  }
}
.multiselect-single-dropdown.reg-reports-width {
  width: 185px;
}
.multiselect-single-dropdown.prod-class-width {
  width: 75%;
  margin-top: 30px;
}
.multiselect-single-dropdown {
  width: 210px;
  float: right;
}
::v-deep .multiselect-single-dropdown .multiselect__single {
  width: 100%;
}
::v-deep .multiselect-single-dropdown .multiselect__option--selected:before {
  top: 10px;
}
::v-deep .multiselect-single-dropdown .multiselect__single .singleLabel_desc {
  float: right;
}
.onefree-label {
  margin-left: -20px;
  margin-bottom: 14px;
}
.one-market-label {
  width: 70%;
}
.onefree-row {
  width: 100%;
}
.pb-10 {
  padding-bottom: 10px;
}
::v-deep .radio-style label:before {
  margin-right: 12px;
}
::v-deep .radio-style {
  margin-top: 4px;
}
@media (min-width: 320px) and (max-width: 568px) {
  .w-reg-100 {
    width: 115% !important;
  }
  .ml-reg-20 {
    margin-left: 20px;
  }
  .w-reg-rep-65 {
    width: 95% !important;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .w-reg-100 {
    width: 120% !important;
  }
}
@media (min-width: 767px) and (max-width: 991px) {
  .box-border-wrapper.reg-intel-wrapper {
    padding: 24px 20px 200px 24px;
  }
}
</style>
